export default __webpack_public_path__ + "static/shaurya-204a308fc2333aa527fab55920c3d7f7.png";